import { TableCell, DateCell } from 'ui/tableCell';
import { JsonView } from 'ui/treeView/JsonView';
import { Accordion, AccordionHeader, AccordionContent } from 'ui/accordion';
import { Link } from 'ui/links';
import type { EventsLogTableColumnData, EventLog } from './types';

export const configureTableColumns = (isUuidBased: boolean): EventsLogTableColumnData[] => {
  return [
    {
      name: isUuidBased ? 'User identifier' : 'User email',
      align: 'flex-start',
      value: isUuidBased ? 'userIdentifier' : 'email',
      RowCell: ({ row }) => {
        const href = isUuidBased
          ? `/users/profiles/${row.userKey}`
          : `/users/profiles/${row.email}`;
        return (
          <TableCell>
            <Link href={href} useReactRouter>
              {isUuidBased ? row.userIdentifier : row.email}
            </Link>
          </TableCell>
        );
      },
    },
    {
      name: 'Event name',
      align: 'flex-start',
      value: 'eventName',
      RowCell: ({ row }) => <TableCell>{row.eventName}</TableCell>,
    },
    {
      name: 'Created',
      align: 'flex-start',
      value: 'createdAt',
      RowCell: ({ row }) => <DateCell timestamp={row.createdAt} />,
    },
    {
      name: 'Raw data',
      align: 'flex-start',
      sortable: false,
      value: 'stringifiedPurchase',
      RowCell: ({ row }) => (
        <TableCell>
          <Accordion>
            <AccordionHeader>Expand to see raw data</AccordionHeader>
            <AccordionContent>
              <JsonView src={row} collapseByDefault />
            </AccordionContent>
          </Accordion>
        </TableCell>
      ),
    },
  ];
};

export const eventsLogFilterFn = (eventLog: EventLog, filter: string) => {
  if (eventLog.email?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (eventLog.userIdentifier?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (eventLog.eventName.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }

  if (eventLog.createdAt.includes(filter)) {
    return true;
  }

  return false;
};
